module.exports = __webpack_public_path__ + "img/t5-black.453ff498.png";